import { ExportByEmailModalTranslations } from "./export-by-email-modal-pt-br";

export const EXPORT_BY_EMAIL_MODAL_FR_FR: ExportByEmailModalTranslations = {
	title: "Exporter le rapport par email",
	description:
		"La période sélectionnée est supérieure à {{days}} jours. Le rapport sera généré en arrière-plan et envoyé à l'email indiqué.",
	emailLabel: "Email",
	emailPlaceholder: "exemple@email.com",
	confirmButton: "Confirmer l'envoi",
	cancelButton: "Annuler",
};
